
import SubscriptionPriceSectionComponent from "../../components/NewDesign/SubscriptionPage/SubscriptionPriceSection/SubscriptionPriceSectionComponent";
import RecommendationView from "../../components/RecommendationView";
import BannerSectionB2C from "../../components/b2cComponents/homepage/BannerSectionB2C";
import CalendarSectionB2C from "../../components/b2cComponents/homepage/CalendarSectionB2C";
import PopularVideoCourse from "../../components/b2cComponents/homepage/PopularVideoCourse";
import SubscriptionPricing from "../../components/b2cComponents/homepage/SubscriptionPricing";
import { getActiveHeader, getActiveHeaderClear } from "../../redux/home/actions";
// import "./HomePageB2c.scss";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
const HomePageB2C = () => {
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(getActiveHeader("home"));
 
 }, []);
 
  return (
    <>
      <PopularVideoCourse />
      <CalendarSectionB2C />
      <section className="recommend-sec">
          <RecommendationView fetchData={true} />
      </section>
      <BannerSectionB2C />
      {/* <SubscriptionPricing /> */}
      <SubscriptionPriceSectionComponent />
    
      {/* <section class="cardsec">
        <div class="container">
          <h2 class="mgt-4 mgb-4-5">The XSEL advantage</h2>
          <ul class="advantage-cards">
            <li class="cardbar">
              <img src="./images/best-content-icon.svg" alt="" />
              <span>Best-in class content</span>
              <p>
                XSEL delivers a full spectrum of foundational, business, sales,
                management and admin training content.
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/planning-scheduling-icon.svg" alt="" />
              <span>Planning and scheduling</span>
              <p>
                Includes a full calendar, communication and notification system
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/training-expertise-icon.svg" alt="" />
              <span>Training expertise</span>
              <p>
                Best-in-class training and coaching from NIIT, the leader in
                comprehensive learning solutions since 1981
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/learning-workflows-icon.svg" alt="" />
              <span>Learning workflows</span>
              <p>
                Customisable Action Paths and checklists with testing,
                certifications and progress tracking
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/integrations-icon.svg" alt="" />
              <span>Integrations</span>
              <p>
                XSEL includes integration with YouTube, Zoom, Live Meeting,
                Google Calendar, PDF, Excel and more
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/gamification-icon.svg" alt="" />
              <span>Gamification</span>
              <p>
                Training is gamified with features such as leaderboards and
                badges
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/management-icon.svg" alt="" />
              <span>Management</span>
              <p>Offers brokerage administration and configuration control</p>
            </li>

            <li class="cardbar">
              <img src="./images/performance-monitoring-icon.svg" alt="" />
              <span>Performance monitoring</span>
              <p>
                Dashboards offer data extraction functionality linking
                performance to training and education
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/compliance-reporting-icon.svg" alt="" />
              <span>Compliance reporting</span>
              <p>
                Track standards and compliance with reporting and management
                functionality
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/role-functionality-icon.svg" alt="" />
              <span>Role-playing functionality</span>
              <p>
                Interactive, live and simulated role plays with the ability to
                record and replay
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/training-analytics-icon.svg" alt="" />
              <span>Training analytics</span>
              <p>
                Deep AI-driven analytics and system-generated training
                recommendations
              </p>
            </li>

            <li class="cardbar">
              <img src="./images/bring-content-icon.svg" alt="" />
              <span>Bring your own content</span>
              <p>
                XSEL also incorporates both your existing and external partner
                content within the platform.
              </p>
            </li>
          </ul>
        </div>
      </section> */}

      <section className="recommend-sec">
          <RecommendationView fetchData={true} />
      </section>

      {/* <section class="belowbanner">
  <div class="container">
    <h2 for="">Get started right away.</h2>
    <p>Gain access to a treasure trove of valuable resources, insightful courses, and expert insights at no cost. Whether you're a beginner or a seasoned pro, our free subscription is your passport to learning and growing in the real estate industry. Don't miss out on this golden opportunity – sign up now and unlock the door to a brighter real estate future, no strings attached!</p>
    <button class="subscriptionbtn">Get free subscription</button>
  </div>
</section> */}
    </>
  );
};
export default HomePageB2C;
